// extracted by mini-css-extract-plugin
export default {"box":"Catalog_box__HLaR9","title":"Catalog_title__PRucX","description":"Catalog_description__7cF75"};